export default {
    path: {
      d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
    },
    properties: {
      viewBox: "0 0 24 24",
      outlined: false,
      strokeWidth: "0",
    },
  }
  